export default __webpack_public_path__ + "static/media/xbrasao.61b33458.png";